export enum LoadingState{
    Loading = 0,
    Loaded = 1,
    Failed = 2
}